import React, { Component } from "react";
import Desktop from "../../components/Desktop";
import Mobile from "../../components/Mobile";
import { connect } from "react-redux";
import { getSettings } from "../../services/settings/actions";
import { getAllLanguages, getSingleLanguageData } from "../../services/languages/actions";
import { hydrateCartFromLocalStorage } from "../../services/cart/actions";
import PushNotificationManager from "../PushNotificationManager";
import { isMobileViewport } from "../../helpers/viewport";

class App extends Component {
  componentDidMount() {
    this.props.getSettings();
    this.props.getAllLanguages();
    this.props.hydrateCartFromLocalStorage();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.languages !== nextProps.languages && Array.isArray(nextProps.languages) && nextProps.languages.length > 0) {
      const preferredLangId = localStorage.getItem("userPreferedLanguage");
      if (preferredLangId) {
        this.props.getSingleLanguageData(preferredLangId);
      } else {
        const defaultLang = nextProps.languages.find(lang => lang.is_default === 1);
        if (defaultLang) {
          this.props.getSingleLanguageData(defaultLang.id);
        }
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <PushNotificationManager />
        {isMobileViewport() ? (
          <Mobile languages={this.props.languages} />
        ) : (
          <Desktop languages={this.props.languages} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.settings.settings,
  user: state.user.user,
  notification_token: state.notification_token.notification_token,
  languages: state.languages.languages,
});

export default connect(mapStateToProps, {
  getSettings,
  getAllLanguages,
  getSingleLanguageData,
  hydrateCartFromLocalStorage,
})(App);
